import { createContext } from "react";

import { FormInstance } from "antd";

export const JourneyFormContext = createContext<{
    form: FormInstance<any> | null;
    formSubmited: boolean;
}>({
    form: null,
    formSubmited: false,
});

export const JourneyFormProvider = ({
    form,
    formSubmited,
    children,
}: {
    form: FormInstance<any> | null;
    formSubmited: boolean;
    children: any;
}) => {
    return (
        <JourneyFormContext.Provider
            value={{
                form,
                formSubmited,
            }}
        >
            {children}
        </JourneyFormContext.Provider>
    );
};
